import { api } from 'shared/api/common'

const baseUrl = '/api/v3/supplier/settings'

function getBusinessSettings () {
  return api.get(`${baseUrl}/business/`)
}

function putBusinessSettings (payload) {
  return api.put(`${baseUrl}/business/`, payload)
}

function getShippingSettings () {
  return api.get(`${baseUrl}/shipping/`)
}

function putShippingSettings (payload) {
  return api.put(`${baseUrl}/shipping/`, payload)
}

function getPaymentSettings () {
  return api.get(`${baseUrl}/payment/`)
}

function putPaymentSettings (payload) {
  return api.put(`${baseUrl}/payment/`, payload)
}

export {
  getBusinessSettings,
  putBusinessSettings,
  getShippingSettings,
  putShippingSettings,
  getPaymentSettings,
  putPaymentSettings,
}
